import { render } from "./MerchantList.vue?vue&type=template&id=1f6508c0"
import script from "./MerchantList.vue?vue&type=script&setup=true&lang=js"
export * from "./MerchantList.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/MerchantList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f6508c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f6508c0', __exports__)) {
    api.reload('1f6508c0', __exports__)
  }
  
  module.hot.accept("./MerchantList.vue?vue&type=template&id=1f6508c0", () => {
    api.rerender('1f6508c0', render)
  })

}


export default __exports__